const engPropositions = ["in", "at", "on", "by", "to", "from", "off", "with"];
const spaPropositions = ["a", "con", "de", "desde", "en", "para", "por", "sin", "con"];

export {engPropositions, spaPropositions}